const featurePairs = [
    ['content-planning', 'planification-contenu'],
    ['asset-revisions', 'versions-fichiers'],
    ['comment-threads', 'fils-commentaires'],
    ['approval-workflows', 'processus-approbation'],
    ['client-review', 'revision-client'],
    ['review-queues', 'files-revision'],
    ['audit-trail', 'historique-audit'],
    ['workspace-access', 'acces-espaces'],
    ['team-collaboration', 'collaboration-equipe'],
];

const pagePairs = [
    { id: 'home', component: 'landing', en: '/', fr: '/fr', sitemap: true },
    { id: 'product', component: 'product', en: '/product', fr: '/fr/produit', sitemap: true },
    ...featurePairs.map(([featureSlug, frenchSlug]) => ({
        id: `feature:${featureSlug}`,
        component: 'product-feature',
        featureSlug,
        en: `/product/${featureSlug}`,
        fr: `/fr/produit/${frenchSlug}`,
        sitemap: true,
    })),
    {
        id: 'pricing',
        component: 'pricing',
        en: '/pricing',
        fr: '/fr/tarifs',
        indexable: false,
        sitemap: false,
    },
    { id: 'blogs', component: 'blogs', en: '/blogs', fr: '/fr/blogues', sitemap: true },
    { id: 'guides', component: 'guides', en: '/guides', fr: '/fr/guides', sitemap: true },
    {
        id: 'guide:approval-workflow',
        component: 'resource',
        resourceSlug: 'social-media-content-approval-workflow',
        en: '/guides/social-media-content-approval-workflow',
        fr: '/fr/guides/workflow-approbation-contenu-social',
        sitemap: true,
        lastmod: '2026-07-29',
    },
    {
        id: 'guide:client-review-checklist',
        component: 'resource',
        resourceSlug: 'client-review-checklist',
        en: '/guides/client-review-checklist',
        fr: '/fr/guides/liste-verification-revision-client',
        sitemap: true,
        lastmod: '2026-07-29',
    },
    {
        id: 'blog:approvals-stuck',
        component: 'resource',
        resourceSlug: 'why-social-media-approvals-get-stuck',
        en: '/blogs/why-social-media-approvals-get-stuck',
        fr: '/fr/blogues/pourquoi-approbations-contenu-bloquent',
        sitemap: true,
        lastmod: '2026-07-29',
    },
    {
        id: 'blog:version-control',
        component: 'resource',
        resourceSlug: 'content-version-control-for-social-teams',
        en: '/blogs/content-version-control-for-social-teams',
        fr: '/fr/blogues/gestion-versions-contenu-social',
        sitemap: true,
        lastmod: '2026-07-29',
    },
    { id: 'terms', component: 'terms', en: '/terms', fr: '/fr/conditions', sitemap: false },
    { id: 'privacy', component: 'privacy', en: '/privacy', fr: '/fr/confidentialite', sitemap: false },
    {
        id: 'privacy-delete',
        component: 'privacy-delete',
        en: '/privacy/delete',
        fr: '/fr/confidentialite/suppression',
        indexable: false,
        sitemap: false,
    },
];

export const publicSeoRoutes = Object.freeze(
    pagePairs.flatMap(pair =>
        ['en', 'fr'].map(locale =>
            Object.freeze({
                id: pair.id,
                component: pair.component,
                featureSlug: pair.featureSlug,
                resourceSlug: pair.resourceSlug,
                locale,
                language: locale === 'fr' ? 'fr-CA' : 'en-CA',
                openGraphLocale: locale === 'fr' ? 'fr_CA' : 'en_CA',
                path: pair[locale],
                alternatePath: pair[locale === 'en' ? 'fr' : 'en'],
                indexable: pair.indexable !== false,
                sitemap: pair.sitemap === true,
                lastmod: pair.lastmod,
            })
        )
    )
);

export const indexablePublicRoutes = Object.freeze(
    publicSeoRoutes.filter(route => route.indexable).map(route => route.path)
);
export const noindexPublicRoutes = Object.freeze(
    publicSeoRoutes.filter(route => !route.indexable).map(route => route.path)
);
export const sitemapPublicRoutes = Object.freeze(
    publicSeoRoutes.filter(route => route.sitemap).map(route => route.path)
);
export const prerenderPublicRoutes = Object.freeze(publicSeoRoutes.map(route => route.path));

export function getPublicSeoRoute(path) {
    return publicSeoRoutes.find(route => route.path === path);
}

export function getPublicPath(id, locale = 'en') {
    return publicSeoRoutes.find(route => route.id === id && route.locale === locale)?.path;
}

export function getProductFeaturePath(featureSlug, locale = 'en') {
    return getPublicPath(`feature:${featureSlug}`, locale);
}

export function isIndexablePublicRoute(path) {
    return getPublicSeoRoute(path)?.indexable === true;
}
